import { render } from "./IconPosition.vue?vue&type=template&id=783f2a50"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPosition.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "783f2a50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('783f2a50', __exports__)) {
    api.reload('783f2a50', __exports__)
  }
  
  module.hot.accept("./IconPosition.vue?vue&type=template&id=783f2a50", () => {
    api.rerender('783f2a50', render)
  })

}


export default __exports__